import { enumerateDevices, findDeviceByLabelOrId } from 'features/user-media/utils';
import { type PendingMediaDeviceInfo } from 'features/user-media/types';
import { safeLocalStorage } from 'utils/storage';
import * as Sentry from '@sentry/react';

export const mapSDKLabelsToDeviceIds = async (
  requestedDevices: Partial<Record<MediaDeviceKind, string>>
) => {
  try {
    const enumeratedMediaDevices = await enumerateDevices();

    Object.entries(requestedDevices).forEach(([kind, deviceIdOrLabel]) => {
      const deviceKind = kind as MediaDeviceKind;
      const availableDevices = enumeratedMediaDevices[deviceKind] || [];

      const resolvedDevice = findDeviceByLabelOrId(availableDevices, deviceIdOrLabel);

      if (resolvedDevice) {
        safeLocalStorage.setItem(kind, JSON.stringify(resolvedDevice));
      } else {
        // Store as pending device for later resolution
        const pendingDevice: PendingMediaDeviceInfo = {
          deviceId: '',
          groupId: '',
          kind: deviceKind,
          label: deviceIdOrLabel,
          isPending: true,
        };
        safeLocalStorage.setItem(kind, JSON.stringify(pendingDevice));
      }
    });
  } catch (error) {
    Sentry.captureException(error);
  }
};
